import { WarningDiamondIcon } from "@xola/icons";
import { Alert } from "@xola/ui-kit";
import React from "react";
import { useAdblockDetect } from "../../hooks/useAdblockDetect";

export const Adblock = () => {
    const isAdblockEnabled = useAdblockDetect();
    if (!isAdblockEnabled) {
        return null;
    }

    return (
        <Alert color="caution">
            <div className="mb-2 text-base font-bold">
                <WarningDiamondIcon /> Ad-blocker enabled
            </div>
            Ad-blockers prevent Xola from collecting data that may help in diagnosing your issue. Please whitelist the
            xola.com domain on your ad-blocker.
        </Alert>
    );
};
